export const language: any = {
    OkLogout: "ใช่",
    CloseLogout: "ไม่ใช่",
    OkLeave: "ออกจากระบบ",
    CloseLeave: "ยกเลิก",
    LabelPolicy: "นโยบายความเป็นส่วนตัว",
    AppName: "Hey! Cooker",
    OnOffNotification: "เปิด/ปิดการแจ้งเตือน",
    LabelReceiveNotificationSuggestion: "รับการแจ้งเตือนคำแนะนำสูตรอาหาร",
    LabelReceiveNotifyBreakfast: "รับคำแนะนำอาหารเช้าทุกวัน",
    LabelReceiveNotifyLunch: "รับคำแนะนำอาหารกลางวันทุกวัน",
    LabelReceiveNotifyDinner: "รับคำแนะนำอาหารเย็นทุกวัน",
    notification_history: "ประวัติการแจ้งเตือน",
    readAll: "อ่านทั้งหมด",
    no_notification: "ไม่มีประวัติการแจ้งเตือน",
    labelDisplayName: "ป้อนชื่อที่แสดง",
    placeholderDisplayName: "ป้อนอย่างน้อย 4 ตัวอักษร สูงสุด 20 ตัวอักษร",
    changeDisplayName: "เปลี่ยนชื่อที่แสดง",
};
